import { Mutations, Actions, ContractState } from "@/types/entities.ts";
import ContractClient from "@/store/service/contractClient.ts";

const state: ContractState = {
  customer: {},
  invoices: [],
};

const getters = {
  currentSource(state: ContractState) {
    const { sources } = state.customer;
    const source = (sources && sources.data) ? sources.data[0] : {};
    return source;
  },
};

const mutations: Mutations = {
  getCustomer: (state, customer) => {
    state.customer = customer;
  },
  getInvoices: (state, invoces) => {
    state.invoices = invoces;
  },
  updateCustomer: (state, customer) => {
    state.customer = Object.assign(state.customer, customer);
  },
};

const actions: Actions = {
  getCustomer: ({commit}) => {
    return new Promise( async (resolve, reject) => {
      try {
        const customer = await ContractClient.getCustomer();
        commit("getCustomer", customer);
        resolve(customer);
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  },

  getInvoices: ({commit}, year ) => {
    return new Promise( async (resolve, reject) => {
      try {
        const invoices = await ContractClient.getInvoices(year);
        commit("getInvoices", invoices);
        resolve(invoices);
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  },

  updatePaymentMethod: ({commit}, newCardToken ) => {
    return new Promise( async (resolve, reject) => {
      try {
        const result = await ContractClient.updateSubscription(newCardToken);
        commit("updateCustomer", result);
        resolve(result);
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
